module.exports = __webpack_public_path__ + "img/39.7f4f8670.jpg";